/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserLocal = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The UserLocal model module.
   * @module model/UserLocal
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>UserLocal</code>.
   * @alias module:model/UserLocal
   * @class
   */
  var exports = function() {
    var _this = this;















  };

  /**
   * Constructs a <code>UserLocal</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UserLocal} obj Optional instance to populate.
   * @return {module:model/UserLocal} The populated <code>UserLocal</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('FirstName')) {
        obj['FirstName'] = ApiClient.convertToType(data['FirstName'], 'String');
      }
      if (data.hasOwnProperty('LastName')) {
        obj['LastName'] = ApiClient.convertToType(data['LastName'], 'String');
      }
      if (data.hasOwnProperty('Email')) {
        obj['Email'] = ApiClient.convertToType(data['Email'], 'String');
      }
      if (data.hasOwnProperty('MobilePhoneNumber')) {
        obj['MobilePhoneNumber'] = ApiClient.convertToType(data['MobilePhoneNumber'], 'String');
      }
      if (data.hasOwnProperty('SystemLanguageID')) {
        obj['SystemLanguageID'] = ApiClient.convertToType(data['SystemLanguageID'], 'Integer');
      }
      if (data.hasOwnProperty('TimeZoneIdentifier')) {
        obj['TimeZoneIdentifier'] = ApiClient.convertToType(data['TimeZoneIdentifier'], 'String');
      }
      if (data.hasOwnProperty('DirectManagerID')) {
        obj['DirectManagerID'] = ApiClient.convertToType(data['DirectManagerID'], 'Integer');
      }
      if (data.hasOwnProperty('ProfileImageURI')) {
        obj['ProfileImageURI'] = ApiClient.convertToType(data['ProfileImageURI'], 'String');
      }
      if (data.hasOwnProperty('HasAccessTo')) {
        obj['HasAccessTo'] = ApiClient.convertToType(data['HasAccessTo'], 'Integer');
      }
      if (data.hasOwnProperty('AdministrationUserTypeID')) {
        obj['AdministrationUserTypeID'] = ApiClient.convertToType(data['AdministrationUserTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('SystemUserTypeID')) {
        obj['SystemUserTypeID'] = ApiClient.convertToType(data['SystemUserTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} FirstName
   * @default ''
   */
  exports.prototype['FirstName'] = '';
  /**
   * @member {String} LastName
   * @default ''
   */
  exports.prototype['LastName'] = '';
  /**
   * @member {String} Email
   * @default ''
   */
  exports.prototype['Email'] = '';
  /**
   * @member {String} MobilePhoneNumber
   * @default ''
   */
  exports.prototype['MobilePhoneNumber'] = '';
  /**
   * @member {Integer} SystemLanguageID
   * @default 0
   */
  exports.prototype['SystemLanguageID'] = 0;
  /**
   * @member {String} TimeZoneIdentifier
   * @default ''
   */
  exports.prototype['TimeZoneIdentifier'] = '';
  /**
   * @member {Integer} DirectManagerID
   * @default 0
   */
  exports.prototype['DirectManagerID'] = 0;
  /**
   * @member {String} ProfileImageURI
   * @default ''
   */
  exports.prototype['ProfileImageURI'] = '';
  /**
   * @member {Integer} HasAccessTo
   * @default 0
   */
  exports.prototype['HasAccessTo'] = 0;
  /**
   * @member {Integer} AdministrationUserTypeID
   * @default 0
   */
  exports.prototype['AdministrationUserTypeID'] = 0;
  /**
   * @member {Integer} CompanyFunctionID
   * @default 0
   */
  exports.prototype['CompanyFunctionID'] = 0;
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {Integer} SystemUserTypeID
   * @default 0
   */
  exports.prototype['SystemUserTypeID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


